import * as URI from 'uri-js';

export const urlRegex =
  // https://www.regextester.com/94502
  // eslint-disable-next-line
  /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;

export const getWebsiteLink = (url: string): string => {
  if (!/^(?:f|ht)tps?:\/\//.test(url)) {
    return `http://${url.replace(/^\/*/, '')}`;
  }
  return url;
};

export const getWebsiteName = (url: string): string => {
  const fullUrl = getWebsiteLink(url);

  return URI.parse(fullUrl).host?.replace(/^www\./, '') || '';
};

const urlValuesForHideSidebar = [
  '/reset-password',
  '/not-found',
  '/access-denied',
];

export const disableSiderMenu = (path: string) =>
  urlValuesForHideSidebar.includes(path);

const defaultIdLength = 36;

export const isURLWithId = (key: string, idLength: number = defaultIdLength) =>
  key.length === idLength;
